import { Container, Grid, Typography, styled } from "@mui/material";
import React from "react";

const MarqueeContainer = styled(Container)`
    padding-top: 50px;
    padding-bottom: 50px;
    background-color: #000024;
    padding-left: 0px !important;
    padding-right: 0px !important;
    @media (max-width: 749px){
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 0px !important;
        padding-right: 0px !important;
    }
`
const BoldText = styled(Typography)`
    color:#fff;
    font-size:50px;
    font-family: poppins-b;
    @media (max-width: 749px){
        font-size:30px;
    }

`
const StrokText = styled(Typography)`
    font-size:50px;
    font-family: poppins-b;
    color:transparent;
    -webkit-text-stroke: 1px #fff;
    @media (max-width: 749px){
        font-size:30px;
    }

`
const Marquee = () => {
    return(
        <MarqueeContainer maxWidth="xxl">
            <Grid container>
                <Grid item xs={12}>
                    <marquee direction="left">
                        <BoldText variant="h1">
                        --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast
                        --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast
                        --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast 
                        --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast 
                        --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast 
                        --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast --- Fast 
                        </BoldText>
                    </marquee>
                    <marquee direction="right">
                        <StrokText variant="h1">
                        --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous 
                        --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous 
                        --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous 
                        --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous 
                        --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous --- Anonymous 
                        </StrokText>
                    </marquee>
                    <marquee direction="left">
                        <BoldText variant="h1">
                        --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure
                        --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure
                        --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure
                        --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure
                        --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure --- Secure
                        </BoldText>
                    </marquee>
                </Grid>
            </Grid>
        </MarqueeContainer>
    );
}

export default Marquee;